/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationV2BatchResponse {
    getFixupPrototypeFunction() { return RecommendationV2BatchResponse.fixupPrototype; }

    static newInstance(model: Partial<RecommendationV2BatchResponse>): RecommendationV2BatchResponse {
        let obj = Object.assign(new RecommendationV2BatchResponse(), model);
        RecommendationV2BatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationV2BatchResponse>): RecommendationV2BatchResponse {
        if (!model) return null;
        return RecommendationV2BatchResponse.newInstance(<RecommendationV2BatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationV2BatchResponse) {
        if (!obj) return;

        models.RecommendationV2BatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationV2BatchResponse): boolean {
        Object.setPrototypeOf(obj, RecommendationV2BatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.RealizedSavingDashboard.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.RealizedSavingDashboard; };

}
